import React, { useEffect, useMemo, useRef, useState } from 'react';

export default function SearchableSelect({
  options,
  value,
  onChange,
  placeholder = 'Buscar...',
  required = false,
  disabled = false,
}) {
  const [aberto, setAberto] = useState(false);
  const [busca, setBusca] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const onClickFora = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAberto(false);
    };
    document.addEventListener('mousedown', onClickFora);
    return () => document.removeEventListener('mousedown', onClickFora);
  }, []);

  const selecionado = options.find((o) => o.value === value);

  const filtradas = useMemo(
    () => options.filter((o) => o.label.toLowerCase().includes(busca.toLowerCase())),
    [options, busca]
  );

  return (
    <div className="position-relative" ref={ref}>
      <button
        type="button"
        className={`form-control sf-select-toggle ${aberto ? 'sf-select-open' : ''}`}
        disabled={disabled}
        onClick={() => setAberto((a) => !a)}
      >
        <span className={selecionado ? '' : 'text-muted'}>
          {selecionado ? (
            <>
              {selecionado.icon && <i className={`bi ${selecionado.icon} ${selecionado.iconColor || ''} me-1`} />}
              {selecionado.label}
            </>
          ) : (
            placeholder
          )}
        </span>
        <i className="bi bi-chevron-down small" />
      </button>

      {aberto && (
        <div className="position-absolute w-100 sf-select-panel mt-1" style={{ zIndex: 1050 }}>
          <div className="sf-select-search">
            <i className="bi bi-search" />
            <input
              autoFocus
              type="text"
              placeholder="Digite para buscar..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />
          </div>
          <ul className="list-unstyled mb-0 sf-select-list">
            {filtradas.length === 0 && <li className="sf-select-empty">Nenhum resultado</li>}
            {filtradas.map((opt) => (
              <li key={opt.value}>
                <button
                  type="button"
                  className={`sf-select-option ${opt.value === value ? 'sf-select-option-active' : ''}`}
                  onClick={() => {
                    onChange(opt.value, opt);
                    setBusca('');
                    setAberto(false);
                  }}
                >
                  {opt.icon && <i className={`bi ${opt.icon} ${opt.iconColor || ''}`} />}
                  {opt.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
